// import { Component, signal, computed } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';

// @Component({
//   selector: 'app-header',
//   standalone: true,
//   imports: [
//     RouterOutlet,
//     RouterLinkWithHref,
//     RouterLink,
//     RouterModule,
//     CommonModule,
//   ],
//   templateUrl: './header.component.html',
//   styleUrl: './header.component.scss',
// })
// export class HeaderComponent implements AfterViewInit {
//   @ViewChild('sidebar') sidebar!: ElementRef;
//   @ViewChild('sidebarToggle') sidebarToggle!: ElementRef;
//   @ViewChild('profileBtn') profileBtn!: ElementRef;
//   @ViewChild('profileMenu') profileMenu!: ElementRef;
//   @ViewChild('pageTitle') pageTitle!: ElementRef;
//   @ViewChild('brandText') brandText!: ElementRef;
//   currentRoute: string = '';
//   collapsed = false;

//   constructor(
//     private el: ElementRef,
//     private router: Router,
//     @Inject(PLATFORM_ID) private platformId: Object
//   ) {

//   }
//   ngAfterViewInit(): void {
//     this.initSidebarToggle();
//     this.initProfileMenu();
//     this.initActiveLinks();
//     this.initEscClose();
//     this.router.events
//       .pipe(filter((event) => event instanceof NavigationEnd))
//       .subscribe((event: any) => {
//         this.currentRoute = event.url;
//       });
//   }

//   /** ------------------------------
//    *  Sidebar Toggle
//    * ------------------------------ */
//   initSidebarToggle() {
//     this.sidebarToggle.nativeElement.addEventListener('click', () => {
//       this.collapsed = !this.collapsed;

//       const sidebarEl = this.sidebar.nativeElement;
//       const labels = this.el.nativeElement.querySelectorAll('.label');

//       if (this.collapsed) {
//         sidebarEl.style.width = '72px';
//         labels.forEach((el: any) => el.classList.add('hidden'));
//         this.brandText.nativeElement.classList.add('hidden');
//       } else {
//         sidebarEl.style.width = '16rem';
//         labels.forEach((el: any) => el.classList.remove('hidden'));
//         this.brandText.nativeElement.classList.remove('hidden');
//       }
//     });
//   }

//   /** ------------------------------
//    * Profile Dropdown
//    * ------------------------------ */
//   private initProfileMenu() {
//     const menu = this.profileMenu.nativeElement;

//     this.profileBtn.nativeElement.addEventListener('click', (e: any) => {
//       e.stopPropagation();
//       menu.classList.toggle('hidden');
//     });

//     document.addEventListener('click', () => menu.classList.add('hidden'));
//   }

//   /** ------------------------------
//    * Active Links + Page Title
//    * ------------------------------ */
//   private initActiveLinks() {
//     const navLinks = this.el.nativeElement.querySelectorAll('.nav-link');

//     navLinks.forEach((link: any) => {
//       link.addEventListener('click', (e: any) => {
//         e.preventDefault();

//         // Remove active state
//         navLinks.forEach((l: any) =>
//           l.classList.remove('bg-indigo-50', 'text-indigo-700', 'font-semibold')
//         );

//         // Add active state
//         link.classList.add('bg-indigo-50', 'text-indigo-700', 'font-semibold');

//         // Update page title
//         const name = link.getAttribute('data-name') || 'Dashboard';
//         this.pageTitle.nativeElement.textContent =
//           name.charAt(0).toUpperCase() + name.slice(1);

//         // Scroll to section
//         const href = link.getAttribute('href');
//         if (href && href.startsWith('#')) {
//           const section = this.el.nativeElement.querySelector(href);
//           if (section) section.scrollIntoView({ behavior: 'smooth' });
//         }
//       });
//     });

//     // Mark first link active
//     if (navLinks.length) {
//       navLinks[0].classList.add(
//         'bg-indigo-50',
//         'text-indigo-700',
//         'font-semibold'
//       );
//     }
//   }

//   /** ------------------------------
//    * ESC key closes dropdown
//    * ------------------------------ */
//   private initEscClose() {
//     document.addEventListener('keydown', (e: any) => {
//       if (e.key === 'Escape') {
//         this.profileMenu.nativeElement.classList.add('hidden');
//       }
//     });
//   }

//   logOut() {
//     if (isPlatformBrowser(this.platformId)) {
//       localStorage.removeItem('Admin_User');
//     }
//     this.router.navigate(['/']);
//   }
// }

import { Component, signal, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  RouterLink,
  RouterLinkWithHref,
  RouterModule,
  RouterOutlet,
  Router,
  NavigationEnd,
  ActivatedRoute,
} from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterOutlet,
    RouterLinkWithHref,
    RouterLink,
    RouterModule,
    CommonModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  breadcrumbs: Array<{ label: string; url: string }> = [];
  isSidebarCollapsed = signal(false);
  pageName: any = signal('');
  routerLinkActive: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.subscribe(() => {
      this.breadcrumbs = this.buildBreadcrumbs(this.route.root);
    });
    this.router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd),map(() => {
        // Walk down to the deepest activated child route
        let route = this.route.root;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot;
      }),
    ).subscribe((snapshot) => {
      // 1. Prefer the route `title` field
      // 2. Fall back to `data.breadcrumb`
      // 3. Fall back to your existing URL-based method
      this.pageName =
        (snapshot.title as string) ??
        (snapshot.data?.['breadcrumb'] as string) ??
        this.extractNameFromUrl(snapshot.url.map((s) => s.path).join('/'));
    });
  }

  toggleSidebar() {
    this.isSidebarCollapsed.update((v) => !v);
  }
  extractNameFromUrl(url: string) {
    const segments = url.split('/');
    if (segments.length >= 5 && segments[3] === 'profile') {
      return segments[4];
    }

    return null;
  }

  logOut() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('Admin_User');
    }
    this.router.navigate(['/']);
  }
  getPageNameFromUrl(url: string): string {
    const parts = url.split('/').filter(Boolean);
    const last = parts[parts.length - 1];
    return last ? last.charAt(0).toUpperCase() + last.slice(1) : '';
  }
  private buildBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: any[] = []
  ): any[] {
    const children = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL = child.snapshot.url
        .map((segment: any) => segment.path)
        .join('/');
      if (routeURL) {
        url += `/${routeURL}`;
      }

      const label =
        child.snapshot.data['breadcrumb'] ||
        routeURL
          .replace(/-/g, ' ')
          .replace(/\b\w/g, (c: any) => c.toUpperCase());

      if (label) {
        breadcrumbs.push({ label, url });
      }

      return this.buildBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
  isRoteHasPermissions(per: any): boolean {
    const isPermisson = this.authService.hasPermission(per);
    if (isPermisson) {
      return isPermisson;
    } else {
      return isPermisson
    }
  }
  mobileSidebarOpen = false;

  toggleMobileSidebar() {
    this.mobileSidebarOpen = !this.mobileSidebarOpen;
  }

  closeMobileSidebar() {
    this.mobileSidebarOpen = false;
  }

  handleSidebarToggle() {

    if (window.innerWidth < 768) {
      this.toggleMobileSidebar();
    } else {
      this.toggleSidebar();
    }

  }
}
